// extracted by mini-css-extract-plugin
export default {"Posters":"Posters_Posters__lsQz4"};